import { CssBaseline } from "@mui/material";
import React from "react";
import { Hero } from "../Component";
// import { Section } from "./Component";

const Homepage = () => {
  return (
    <React.Fragment>
      <CssBaseline />
      {/* <Section /> */}
      <Hero />
    </React.Fragment>
  );
};

export default Homepage;
